interface Props {
  [key: string]: any
}

export default function EyeOpenIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 29 28" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M14.8344 10.4412C13.9114 10.4412 13.0261 10.8079 12.3735 11.4605C11.7208 12.1132 11.3541 12.9985 11.3541 13.9215C11.3541 14.8445 11.7208 15.7298 12.3735 16.3825C13.0261 17.0352 13.9114 17.4018 14.8344 17.4018C15.7575 17.4018 16.6427 17.0352 17.2954 16.3825C17.9481 15.7298 18.3147 14.8445 18.3147 13.9215C18.3147 12.9985 17.9481 12.1132 17.2954 11.4605C16.6427 10.8079 15.7575 10.4412 14.8344 10.4412ZM14.8344 19.722C13.296 19.722 11.8206 19.1109 10.7328 18.0231C9.64501 16.9353 9.03389 15.4599 9.03389 13.9215C9.03389 12.3831 9.64501 10.9077 10.7328 9.81991C11.8206 8.7321 13.296 8.12097 14.8344 8.12097C16.3728 8.12097 17.8482 8.7321 18.936 9.81991C20.0238 10.9077 20.635 12.3831 20.635 13.9215C20.635 15.4599 20.0238 16.9353 18.936 18.0231C17.8482 19.1109 16.3728 19.722 14.8344 19.722ZM14.8344 5.2207C9.03389 5.2207 4.08023 8.82864 2.07324 13.9215C4.08023 19.0144 9.03389 22.6223 14.8344 22.6223C20.635 22.6223 25.5886 19.0144 27.5956 13.9215C25.5886 8.82864 20.635 5.2207 14.8344 5.2207Z"
        fill="white"
      />
    </svg>
  )
}
